import template from './modalCreateDelegation.html';
import controller from './modalCreateDelegation.controller';
import './modalCreateDelegation.scss';

let modalCreateDelegationComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    role: '<',
    module: '<',
    onSend: '&',
    onDismiss: '&',
    onDelegationTypeChange: '&',
    employeeId: '<',
  },
  template,
  controller,
};

export default modalCreateDelegationComponent;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCreateDelegation/modalCreateDelegation.component.js